import api from "./api";
import { useEffect, useState } from "react";
import { useUserSuperEmpresa } from "../Context/AuthContext";

export const getResumenMensualRme = async ({ anio = null, mes = null } = {}) => {
  const response = await api.get("/resumenMensual", {
    params: {
      anio,
      mes,
    },
  });

  return response.data;
};


export const useGetRMEMensualReporte = (filtros = {}) => {
  const { Token } = useUserSuperEmpresa();

  const [resumenMensual, setResumenMensual] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchResumen = async () => {
    setLoading(true);
    try {
      const data = await getResumenMensualRme({
        anio: filtros.anio,
        mes: filtros.mes,
      });

      setResumenMensual(data);
    } catch (err) {
      setError(err.response?.data?.message || "Error al obtener resumen mensual");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Token) {
      fetchResumen();
    }
  }, [Token, filtros?.anio, filtros?.mes]);

  return {
    resumenMensual,
    loading,
    error,
    refetch: fetchResumen,
  };
};
